<template>
  <v-navigation-drawer
    v-model="drawer"
    :rail="rail"
    permanent
    class="sidebar-left"
    @click="rail = false"
  >
    <!-- Cabeçalho com Logo -->
    <v-list-item
      class="sidebar-header"
      nav
    >
      <template #prepend>
        <img
          :src="require(`@/assets/drMedicPro_.png`)"
          alt="Logo"
          class="header-logo"
        >
      </template>
      <v-list-item-title class="header-title">
        DR MedicPro
      </v-list-item-title>
      <template #append>
        <v-btn
          variant="text"
          :icon="rail ? 'menu' : 'chevron_left'"
          class="rail-toggle-btn"
          @click.stop="rail = !rail"
        />
      </template>
    </v-list-item>

    <v-divider />

    <!-- Itens de Navegação -->
    <v-list
      density="compact"
      nav
      class="nav-list"
    >
      <v-tooltip 
        v-for="(item, index) in navigationItems" 
        :key="item.titulo"
        :text="item.titulo" 
        location="end" 
        :disabled="!rail"
      >
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            :title="item.titulo"
            class="nav-item"
            :active="activeIndex === index"
            @click="handleItemClick(index)"
          >
            <template #prepend>
              <v-icon>{{ item.icone }}</v-icon>
            </template>
          </v-list-item>
        </template>
      </v-tooltip>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import EventBus from '@/EventBus'

export default {
  name: 'ModernSidebarLeft',
  data: () => ({
    drawer: true,
    rail: true,
    activeIndex: 0,
    navigationItems: [
      {
        icone: 'groups',
        titulo: 'Meus Pacientes'
      },
      {
        icone: 'history',
        titulo: 'Meus Atendimentos'
      },
      {
        icone: 'settings',
        titulo: 'Configurações'
      }
    ]
  }),
  
  mounted() {
    EventBus.on('setActiveIndex', (index) => {
      this.activeIndex = index;
    });
  },
  
  beforeUnmount() {
    EventBus.off('setActiveIndex');
  },
  
  methods: {
    handleItemClick(index) {
      this.activeIndex = index;
      this.$emit('selecionado', index);
    }
  }
}
</script>

<style scoped>
.sidebar-left {
  border-right: 1px solid rgba(var(--v-theme-on-surface), 0.1);
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Header */
.sidebar-header {
  height: 80px;
  padding: 0 12px;
}

.header-logo {
  height: 36px;
  width: 36px;
  object-fit: contain;
  margin-left: 4px;
}

.header-title {
  font-weight: 600;
  font-size: 1.1rem;
  margin-left: 12px;
}

.rail-toggle-btn {
  font-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
}

.v-navigation-drawer--rail .rail-toggle-btn {
  transform: rotate(180deg);
}


/* Lista de Navegação */
.nav-list {
  padding: 8px;
}

.nav-item {
  margin: 4px 0;
  border-radius: 8px !important;
  transition: background-color 0.2s ease, color 0.2s ease;
}

/* Estilo do item quando o mouse está sobre ele */
.nav-item:hover:not(.v-list-item--active) {
  background-color: rgba(var(--v-theme-on-surface), 0.04);
}

/* Estilo do item ativo */
.v-list-item--active {
  background-color: rgba(var(--v-theme-primary), 0.1);
  color: rgb(var(--v-theme-primary));
  font-weight: 500;
}

/* Ajustes finos nos ícones e texto */
.nav-item :deep(.v-list-item__prepend .v-icon) {
  margin-inline-end: 16px;
}

.v-navigation-drawer--rail .nav-item :deep(.v-list-item__prepend .v-icon) {
  margin-inline-end: auto;
}

.nav-item :deep(.v-list-item-title) {
  font-size: 0.9rem;
  font-weight: 500;
}

.v-list-item--active :deep(.v-list-item-title) {
  font-weight: 700;
}

</style>